module.exports = __webpack_public_path__ + "static/media/less.ce4229fc.png";